import React from "react";
import { Lock, FileText } from "lucide-react";

/**
 * Evidence custody panel.
 * Left = shared evidence (references only).
 * Right = withheld evidence count + custodian metadata, kept at source.
 */
export default function EvidenceCustody({ evidence, testId = "evidence-custody-panel" }) {
    const shared = evidence?.shared || [];
    const withheld = evidence?.withheld || [];
    return (
        <div className="panel" data-testid={testId}>
            <div className="px-5 md:px-6 py-3 border-b border-parchment-rule flex items-baseline justify-between">
                <span className="label-eyebrow">Evidence Custody</span>
                <span className="font-mono text-[11px] tracking-[0.18em] uppercase text-ink-muted">
                    Raw evidence stays at source · references shared only
                </span>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2">
                <div className="p-5 md:p-6 border-r border-parchment-rule">
                    <div className="flex items-center gap-2 mb-3">
                        <FileText size={14} strokeWidth={1.5} className="text-forest" />
                        <span className="label-eyebrow">Shared with insurer</span>
                        <span className="font-mono text-[11px] text-ink-muted">
                            ({shared.length})
                        </span>
                    </div>
                    {shared.length === 0 ? (
                        <p className="text-sm text-ink-muted">No shared evidence yet.</p>
                    ) : (
                        <ul className="space-y-2" data-testid="shared-evidence-list">
                            {shared.map((it, i) => (
                                <li key={i} className="border-b border-parchment-rule pb-2 last:border-b-0">
                                    <div className="text-sm">{it.label}</div>
                                    <div className="data-cell text-xs">
                                        ref: {it.ref}  ·  custodian: {it.custodian}
                                    </div>
                                </li>
                            ))}
                        </ul>
                    )}
                </div>
                <div className="p-5 md:p-6 bg-[#F2EFE9]">
                    <div className="flex items-center gap-2 mb-3">
                        <Lock size={14} strokeWidth={1.5} className="text-oxblood" />
                        <span className="label-eyebrow">Withheld at source</span>
                        <span className="font-mono text-[11px] text-ink-muted">
                            ({withheld.length})
                        </span>
                    </div>
                    {withheld.length === 0 ? (
                        <p className="text-sm text-ink-muted">No withheld evidence declared.</p>
                    ) : (
                        <ul className="space-y-2" data-testid="withheld-evidence-list">
                            {withheld.map((it, i) => (
                                <li key={i} className="border-b border-parchment-rule pb-2 last:border-b-0">
                                    <div className="text-sm">{it.label}</div>
                                    <div className="data-cell text-xs text-ink-muted">
                                        ref: {it.ref}  ·  retained by {it.custodian}
                                    </div>
                                </li>
                            ))}
                        </ul>
                    )}
                    <p className="text-xs text-ink-muted font-mono uppercase tracking-[0.18em] mt-4">
                        Withheld content never leaves source. Only a count is recorded on the receipt.
                    </p>
                </div>
            </div>
        </div>
    );
}
